// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3cX7v","title":"Header_title__1NPwB","left":"Header_left__3hYFe","clinicName":"Header_clinicName__2KhE5"};